import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import ModelList from './pages/ModelList';
import ModelUpload from './pages/ModelUpload';
import TestModel from './pages/TestModel';
import History from './pages/History';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <nav className="navbar">
          <div className="nav-container">
            <h1 className="logo">🤖 Model Platform</h1>
            <div className="nav-links">
              <Link to="/">Models</Link>
              <Link to="/upload">Upload</Link>
              <Link to="/test">Test</Link>
              <Link to="/history">History</Link>
            </div>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<ModelList />} />
            <Route path="/upload" element={<ModelUpload />} />
            <Route path="/test" element={<TestModel />} />
            <Route path="/test/:modelId" element={<TestModel />} />
            <Route path="/history" element={<History />} />
          </Routes>
        </main>

        <footer className="footer">
          <p>Powered by Cloudflare Workers + ONNX Runtime Web</p>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;

